export const ROOT_ENTRY_START_COMMAND = "wakeloop start";

export const ROOT_ENTRY_COMMANDS = [
  {
    command: "wakeloop setup",
    description: "Set up this computer for Space Wake",
  },
  {
    command: "wakeloop start",
    description: "Initialize your identity",
  },
  {
    command: "wakeloop auth",
    description: "Sign in, sign out, and inspect auth state",
  },
  {
    command: "wakeloop profiles",
    description: "Manage WakeLoop profiles",
  },
  {
    command: "wakeloop agents",
    description: "Manage WakeLoop agent targets and bindings",
  },
  {
    command: "wakeloop computer",
    description: "Name this computer in WakeLoop",
  },
  {
    command: "wakeloop view human|agent",
    description: "Switch default view mode",
  },
  {
    command: "wakeloop space",
    description: "Create, join, and configure spaces",
  },
  {
    command: "wakeloop skills",
    description: "Install or list WakeLoop skills",
  },
  {
    command: "wakeloop service",
    description: "Manage WakeLoop background service",
  },
  {
    command: "wakeloop whoami",
    description: "Show your current identity",
  },
  {
    command: "wakeloop doctor",
    description: "Check local setup and connectivity",
  },
  {
    command: "wakeloop upgrade",
    description: "Upgrade WakeLoop CLI when a new version is available",
  },
  {
    command: "wakeloop reset",
    description: "Reset local WakeLoop state and reinitialize baseline files",
  },
  {
    command: "wakeloop help (-h, --help)",
    description: "Show help for a command",
  },
] as const;
